/**
 * Shop Locator layout (bskr/layout-shop-locator) — scroll-triggered fade/rise of
 * the headline and the photo.
 *
 * Loaded globally (layouts can't ship reliable per-block scripts). Skips the
 * editor and respects prefers-reduced-motion (everything stays visible).
 */

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function initBlock(root) {
  if (root.dataset.shopLocatorInited === "1") return;

  const picture = root.querySelector(".bskr-shop-locator__picture");
  if (!picture) return;

  // Inside a Content Slider slide the vertical scroll trigger can't fire (the
  // slide is translated horizontally); skip the reveal so the content keeps its
  // default visible state (see content-slider.js / content-slide markup).
  if (root.closest("[data-no-scroll-reveal]")) return;

  root.dataset.shopLocatorInited = "1";
  // Flag the section so the CSS hides the picture (avoids a flash before GSAP
  // takes over); only added here, so no-JS users keep it visible.
  root.classList.add("is-anim-ready");

  const headline = root.querySelector(".bskr-layout-shop-locator__content .wpbb-container, .bskr-layout-shop-locator__content .wp-bootstrap-blocks-container");

  if (headline) {
    gsap.from(headline, {
      opacity: 0,
      y: 24,
      duration: 0.6,
      ease: "power2.out",
      scrollTrigger: { trigger: root, start: "top 80%", once: true },
    });
  }

  gsap.set(picture, { opacity: 0, y: 40 });
  gsap.to(picture, {
    opacity: 1,
    y: 0,
    duration: 0.8,
    ease: "power2.out",
    scrollTrigger: { trigger: picture, start: "top 90%", once: true },
  });
}

function init() {
  // Skip in the editor; leave reduced-motion users with static, visible content.
  if (typeof window !== "undefined" && window.wp && window.wp.data) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  document
    .querySelectorAll(".wp-block-bskr-layout-shop-locator")
    .forEach(initBlock);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
